@if (isLoading) {
  <ui-loading-spinner></ui-loading-spinner>
}

@if (!isLoading) {
  <div class="draft-detail-page-heading">
    <span class="title-large-emphasized">
      {{ 'receipts.ui.brogliaccioN' | transloco: { value0: (dettaglio.numeroBrogliaccio) } }}
    </span>
  </div>
}

<div class="draft-detail-content">
  <div class="draft-detail-heading">
    <span class="body-medium draft-status-badge" [ngClass]="statusBadgeClass(dettaglio.situazione)">
      {{ dettaglio.situazione }}
    </span>
  </div>

  @if (dettaglio.versamentiContanti.length > 0) {
    <div class="draft-detail-group">
      <span class="label-medium-emphasized">{{ 'receipts.ui.versamentiInContanteConfluiti' | transloco }}</span>

      @for (versamento of dettaglio.versamentiContanti; track versamento.idIncasso) {
        <div class="draft-detail-card">
          <div class="draft-detail-card-text">
            <div class="draft-detail-first-row">
              <div class="draft-detail-pair">
                <span class="body-small">{{ 'receipts.ui.incasso2' | transloco }}</span>
                <span class="body-small-emphasized">{{ versamento.idIncasso }}</span>
              </div>
              <div class="draft-detail-pair">
                <span class="body-small">{{ 'receipts.ui.data3' | transloco }}</span>
                <span class="body-small-emphasized">
                  {{ versamento.dataIncasso | date:'dd/MM/yyyy' }}
                </span>
              </div>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">{{ 'receipts.ui.cliente2' | transloco }}</span>
              <span class="body-small-emphasized">{{ versamento.cliente }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">{{ 'receipts.ui.monete2' | transloco }}</span>
              <span class="body-small-emphasized">
                {{ versamento.importoMonete | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
              </span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">{{ 'receipts.ui.banconote' | transloco }}</span>
              <span class="body-small-emphasized">
                {{ versamento.importoBanconote | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
              </span>
            </div>
            <div class="draft-detail-row">
              <span class="body-large-emphasized">{{ 'receipts.ui.totale3' | transloco }}</span>
              <span class="body-large-emphasized">
                {{ versamento.importoTotale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (dettaglio.assegni.length > 0) {
    <div class="draft-detail-group">
      <span class="label-medium-emphasized">{{ 'receipts.ui.assegniConfluiti' | transloco }}</span>

      @for (assegno of dettaglio.assegni; track $index) {
        <div class="draft-detail-card">
          <div class="draft-detail-card-text">
            <div class="draft-detail-first-row">
              <div class="draft-detail-pair">
                <span class="body-small">{{ 'receipts.ui.incasso2' | transloco }}</span>
                <span class="body-small-emphasized">{{ assegno.idIncasso }}</span>
              </div>
              <div class="draft-detail-pair">
                <span class="body-small">{{ 'receipts.ui.data3' | transloco }}</span>
                <span class="body-small-emphasized">
                  {{ assegno.dataIncasso | date:'dd/MM/yyyy' }}
                </span>
              </div>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">{{ 'receipts.ui.cliente2' | transloco }}</span>
              <span class="body-small-emphasized">{{ assegno.cliente }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">{{ 'receipts.ui.abi2' | transloco }}</span>
              <span class="body-small-emphasized">{{ assegno.abi }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">{{ 'receipts.ui.cab' | transloco }}</span>
              <span class="body-small-emphasized">{{ assegno.cab }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">{{ 'receipts.ui.banca2' | transloco }}</span>
              <span class="body-small-emphasized">{{ assegno.banca }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">{{ 'receipts.ui.nAssegno' | transloco }}</span>
              <span class="body-small-emphasized">{{ assegno.numeroAssegno }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-large-emphasized">{{ 'receipts.ui.importo2' | transloco }}</span>
              <span class="body-large-emphasized">
                {{ assegno.importo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <div class="draft-detail-group">
    <span class="label-medium-emphasized">{{ 'receipts.ui.partiteAssociate' | transloco }}</span>

    @for (partita of dettaglio.partiteAssociate; track partita.numeroDocumento) {
      <div class="draft-detail-card">
        <div class="draft-detail-card-text">
          <div class="draft-detail-row">
            <span class="body-small">{{ 'receipts.ui.numDoc' | transloco }}</span>
            <span class="body-small-emphasized">{{ partita.numeroDocumento }}</span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">{{ 'receipts.ui.dataDocumento' | transloco }}</span>
            <span class="body-small-emphasized">
              {{ partita.dataDocumento | date:'dd/MM/yyyy' }}
            </span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">{{ 'receipts.ui.scadenza' | transloco }}</span>
            <span class="body-small-emphasized">
              {{ partita.dataScadenza | date:'dd/MM/yyyy' }}
            </span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">{{ 'receipts.ui.totaleFattura' | transloco }}</span>
            <span class="body-small-emphasized">
              {{ partita.totaleFattura | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
            </span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">{{ 'receipts.ui.assegnato' | transloco }}</span>
            <span class="body-small-emphasized">
              {{ partita.importoAssegnato | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
            </span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">{{ 'receipts.ui.residuo' | transloco }}</span>
            <span class="body-small-emphasized">
              {{ partita.importoResiduo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
            </span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">{{ 'receipts.ui.daIncasso' | transloco }}</span>
            <span class="body-small-emphasized">{{ partita.idIncasso }}</span>
          </div>
        </div>
      </div>
    }
  </div>

  @if (dettaglio.acconti.length > 0) {
    <div class="draft-detail-group">
      <span class="label-medium-emphasized">{{ 'receipts.ui.accontiConfluiti' | transloco }}</span>

      @for (acconto of dettaglio.acconti; track acconto.codiceCliente) {
        <div class="draft-detail-card">
          <div class="draft-detail-card-text">
            <div class="draft-detail-first-row">
              <div class="draft-detail-pair">
                <span class="body-small">{{ 'receipts.ui.incasso2' | transloco }}</span>
                <span class="body-small-emphasized">{{ acconto.idIncasso }}</span>
              </div>
              <div class="draft-detail-pair">
                <span class="body-small">{{ 'receipts.ui.codCliente' | transloco }}</span>
                <span class="body-small-emphasized">{{ acconto.codiceCliente }}</span>
              </div>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">{{ 'receipts.ui.cliente2' | transloco }}</span>
              <span class="body-small-emphasized">{{ acconto.cliente }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-large-emphasized">{{ 'receipts.ui.importo2' | transloco }}</span>
              <span class="body-large-emphasized">
                {{ acconto.importo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<div class="draft-detail-summary">
  <span class="body-large-emphasized">{{ 'receipts.ui.riepilogo' | transloco }}</span>

  <div class="draft-summary-row">
    <span class="body-small">{{ 'receipts.ui.totaleContanti2' | transloco }}</span>
    <span class="body-small-emphasized">
      {{ dettaglio.riepilogo.totaleContanti | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
    </span>
  </div>

  <div class="draft-summary-row">
    <span class="body-small">{{ 'receipts.ui.totaleAssegni2' | transloco }}</span>
    <span class="body-small-emphasized">
      {{ dettaglio.riepilogo.totaleAssegni | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
    </span>
  </div>

  <div class="draft-detail-divider"></div>

  <div class="draft-summary-row">
    <span class="headline-small-emphasized">{{ 'receipts.ui.totaleGenerale' | transloco }}</span>
    <span class="headline-small-emphasized">
      {{ dettaglio.riepilogo.totaleGenerale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
    </span>
  </div>
</div>

@if (puoConfermare) {
  <button
    matButton="filled"
    type="button"
    class="draft-detail-confirm-button"
    *uiCan="CAPS.brogliaccioConferma"
    [disabled]="isSaving"
    (click)="conferma()"
  >
    {{ 'receipts.ui.conferma' | transloco }}
  </button>
}

@if (puoEliminare) {
  <button
    matButton="outlined"
    type="button"
    class="draft-detail-delete-button draft-detail-delete-mobile-button"
    *uiCan="CAPS.brogliaccioElimina"
    [disabled]="isSaving"
    (click)="elimina()"
  >
    {{ 'receipts.ui.elimina' | transloco }}
  </button>
}

<button
  matButton="outlined"
  type="button"
  class="draft-detail-download-mobile-button"
  [disabled]="isDownloadingPdf"
  (click)="scaricaPdf()"
>
  {{ 'receipts.ui.scaricaPdf' | transloco }}
</button>

<div class="draft-detail-desktop">
  @if (dettaglio.versamentiContanti.length > 0) {
    <section class="draft-detail-desktop-card">
      <span class="label-medium-emphasized">{{ 'receipts.ui.versamentiInContanteConfluiti' | transloco }}</span>
      <ui-table-view
        [columnsInfo]="versamentiContantiColumns"
        [data]="versamentiContantiTable"
      />
    </section>
  }

  @if (dettaglio.assegni.length > 0) {
    <section class="draft-detail-desktop-card">
      <span class="label-medium-emphasized">{{ 'receipts.ui.assegniConfluiti' | transloco }}</span>
      <ui-table-view
        [columnsInfo]="assegniColumns"
        [data]="assegniTable"
      />
    </section>
  }

  <section class="draft-detail-desktop-card">
    <span class="label-medium-emphasized">{{ 'receipts.ui.partiteAssociate' | transloco }}</span>
    <ui-table-view
      [columnsInfo]="partiteAssociateColumns"
      [data]="partiteAssociateTable"
    />
  </section>

  @if (dettaglio.acconti.length > 0) {
    <section class="draft-detail-desktop-card">
      <span class="label-medium-emphasized">{{ 'receipts.ui.accontiConfluiti' | transloco }}</span>
      <ui-table-view
        [columnsInfo]="accontiColumns"
        [data]="accontiTable"
      />
    </section>
  }

  <section class="draft-detail-desktop-card draft-detail-desktop-summary">
    <div class="draft-detail-desktop-heading">
      <span class="label-medium-emphasized">{{ 'receipts.ui.riepilogo' | transloco }}</span>
      <span class="body-medium draft-status-badge" [ngClass]="statusBadgeClass(dettaglio.situazione)">
        {{ dettaglio.situazione }}
      </span>
    </div>

    <div class="draft-detail-desktop-fields">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'receipts.ui.totaleContanti' | transloco }}</mat-label>
        <input
          matInput
          readonly
          [value]="dettaglio.riepilogo.totaleContanti | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR'"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'receipts.ui.totaleAssegni' | transloco }}</mat-label>
        <input
          matInput
          readonly
          [value]="dettaglio.riepilogo.totaleAssegni | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR'"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'receipts.ui.totaleGenerale2' | transloco }}</mat-label>
        <input
          matInput
          readonly
          [value]="dettaglio.riepilogo.totaleGenerale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR'"
        />
      </mat-form-field>
    </div>

    <div class="draft-detail-desktop-actions">
      @if (puoConfermare) {
        <button
          matButton="filled"
          type="button"
          class="draft-detail-action-wide"
          *uiCan="CAPS.brogliaccioConferma"
          [disabled]="isSaving"
          (click)="conferma()"
        >
          {{ 'receipts.ui.conferma' | transloco }}
        </button>
      }
      <button
        matButton="outlined"
        type="button"
        class="draft-detail-action-wide"
        [disabled]="isDownloadingPdf"
        (click)="scaricaPdf()"
      >
        {{ 'receipts.ui.scaricaPdf' | transloco }}
      </button>
      <button matButton="outlined" type="button" (click)="tornaIndietro()">
        {{ 'receipts.ui.esci' | transloco }}
      </button>
      @if (puoEliminare) {
        <button
          matButton="outlined"
          type="button"
          class="draft-detail-delete-button"
          *uiCan="CAPS.brogliaccioElimina"
          [disabled]="isSaving"
          (click)="elimina()"
        >
          {{ 'receipts.ui.elimina' | transloco }}
        </button>
      }
    </div>
  </section>
</div>
